import React, {useRef, useEffect, useMemo} from "react";
import {AgGridReact} from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";

function InstagramCampaignDetails() {
    const gridRef = useRef();

    const columnDefs = [
                        { field: 'index', headerName: 'No.', valueGetter: "node.rowIndex + 1", width: 60 },
                        { field: 'id', headerName: 'Campaign ID', filter: 'agNumberColumnFilter', width: 100},
                        { field: 'template', headerName: 'Template', filter: 'agTextColumnFilter', width: 140},
                        { field: 'jobid', headerName: 'Job ID', filter: 'agNumberColumnFilter', width: 100 },
                        { field: 'user', headerName: 'User', filter: 'agTextColumnFilter', width: 180 },
                        { field: 'total', headerName: 'Total', filter: 'agNumberColumnFilter', width: 100 },
                        { field: 'sent', headerName: 'Sent', filter: 'agNumberColumnFilter', width: 100 },
                        { field: 'remaining', headerName: 'Remaining', filter: 'agNumberColumnFilter', width: 100 },
                        { field: 'failed', headerName: 'Failed', filter: 'agNumberColumnFilter', width: 100 },
                        { field: 'Status', headerName: 'Status', filter: 'agTextColumnFilter', width: 100 },
                    ];

    const refreshgrid=()=>{
        gridRef.current.api?.refreshServerSide([])
    }

    const datasource = {
        getRows: function (params)  {
            const serverApiUrl = `/api/instagramcampaigndetailsview`;

            fetch(serverApiUrl, {
                method: 'post',
                body: JSON.stringify({...params.request}),
                headers: { "Content-Type": "application/json; charset=utf-8","Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}`},
            })
            .then(httpResponse => httpResponse.json())
            .then(response => {
                params.successCallback(response.rows, response.lastRow);
            })
            .catch(error => {
                console.error(error);
                params.failCallback();
            });
        }
    };

    useEffect(() => {
        gridRef.current.api?.refreshServerSide([]);
    }, [])

    const sideBar = useMemo(() => {
        return {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel',
            },
            {
              id: 'filters',
              labelDefault: 'Filters',
              labelKey: 'filters',
              iconKey: 'filter',
              toolPanel: 'agFiltersToolPanel',
            }
          ],
          defaultToolPanel: '',
        };
      }, []);

    const defaultColDef={
        sortable: true,
        filter: true,
        resizable: true,
        floatingFilter: false,
        enableValue: true,
        enableRowGroup: true,
        enablePivot: true,
        suppressMenu: true,
    }
    

    const onGridReady = (params) => {
        gridRef.current.api?.setServerSideDatasource(datasource);
    };

  return (
    <React.Fragment>
        <div className="m-0 p-0 h-100 d-flex flex-row">
            <div className="border h-100 ag-theme-balham" style={{width: "100%"}}>
                <AgGridReact
                    ref={gridRef}
                    defaultColDef={defaultColDef}
                    onGridReady={onGridReady}
                    columnHoverHighlight={'true'}
                    suppressRowGroupHidesColumns={'true'}
                    cacheBlockSize={50}
                    rowModelType={'serverSide'}
                    columnDefs= {columnDefs}
                    sideBar= {sideBar}
                />
            </div>
        </div>
    </React.Fragment>
  )
}

export default InstagramCampaignDetails;